const PATIENT_DRAFT_PREFIXES = ["intakeDraft", "progressDraft", "dailySessionDraft"];

export function patientDraftKey(type, userId, ...parts) {
  if (!userId) return null;
  return [type, userId, ...parts.filter((part) => part !== undefined && part !== null)].join(":");
}

export function clearPatientDraftStorage(userId) {
  if (!userId) return;
  const prefixes = PATIENT_DRAFT_PREFIXES.map((prefix) => `${prefix}:${userId}`);
  Object.keys(localStorage)
    .filter((key) => prefixes.some((prefix) => key === prefix || key.startsWith(`${prefix}:`)))
    .forEach((key) => localStorage.removeItem(key));
}
